// Who may open a product page in each status, and whether it sells anything.
//
// Live is open to everyone. Every other status keeps the page for its seller and
// for anyone who already bought the product, with nothing to buy on it.
// Archiving, deleting, a moderation takedown and a seller's ban (the last two
// both 'unpublished') all take a listing off sale, and none of them may take a
// purchase away: the page is where downloads, the licence and the refund route
// live. The admin console promises staff that buyers keep their files and their
// money, and the Terms promise that a one-off purchase can be downloaded again
// at any time. A takedown used to fall through to a catch-all that let only the
// seller in (2026-10-26 audit, item 14). /api/download never checked the status,
// so this page was the only thing in the way.
//
// Pure, so the node test runner can load it.

export type ProductPageAccess = 'open' | 'owner' | 'closed';

/**
 * How a viewer may see a product page.
 *
 * @param status The product's status.
 * @param viewer Whether they are its seller, and whether they own it.
 */
export function productPageAccess(
  status: unknown,
  viewer: { isMerchant?: boolean; isPurchased?: boolean },
): ProductPageAccess {
  if (status === 'live') return 'open';
  return viewer.isMerchant || viewer.isPurchased ? 'owner' : 'closed';
}

/** Whether the product cannot be bought, whoever is looking. */
export function isOffSale(status: unknown): boolean {
  return status !== 'live';
}

/**
 * Whether the closed page should offer a guest the form that emails a fresh
 * access link. Anywhere a buyer can exist, which is everywhere but a draft:
 * the rules refuse live -> draft, so a draft has never sold.
 */
export function offersGuestAccess(status: unknown): boolean {
  return status !== 'draft';
}
